import { GetAllEarlyBirdInformationByGuid, GetAllEarlyBirdInformationByGuidResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<GetAllEarlyBirdInformationByGuidResponse, GetAllEarlyBirdInformationByGuidResponse>) => response?.data?.earlyBirdRegistration;

const getError = (response?: SWRResponse<GetAllEarlyBirdInformationByGuidResponse, GetAllEarlyBirdInformationByGuidResponse>) => (response?.error ?? response?.data)?.responseStatus;


const getAdditionalState = (response?: SWRResponse<GetAllEarlyBirdInformationByGuidResponse, GetAllEarlyBirdInformationByGuidResponse>) => ({
    earlyBirdRegistration: response?.data?.earlyBirdRegistration,
    isLoading: !response?.data && !response?.error
});

export const useEarlyBirdByRegistrationId = (guid?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetAllEarlyBirdInformationByGuid({guid});
        };
    }, [guid])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useEarlyBirdByRegistrationId;